export enum OrderPrioritizationLabels {
  dialogInputButton = 'Confirmar',
  dialogInputTitle = 'Fecha de entrega a embarques',
  toastMessageFileCreatedError = 'No se pudo generar el archivo en el FTP',
  toastMessageFileCreatedSuccess = 'Archivo(s) guardado(s) correctamente',
  toastMessageFileWarning = 'El archivo no será generado en el FTP'
}
